import { ModalStore, ModalType, ModalProps } from '@/types/stores/modal';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useModalStore = create<ModalStore>()(
  persist(
    (set, get) => ({
      type: null,
      props: null,

      open: <T extends ModalType>(type: T, props?: ModalProps<T>) => {
        set({ type, props: props ?? null });
      },

      close: () => {
        const onClose = get().props?.onClose;

        if (onClose && typeof onClose == 'function') {
          onClose();
        }

        set({ type: null, props: null });
      },
    }),
    {
      name: 'modal-store',
    },
  ),
);

export default useModalStore;
